<template>
  <v-layout align-start row wrap>
    <v-flex xs12 sm12 pb-0 pt-0>
      <v-data-table :headers="headers" :items="Vacaciones" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Solicitudes de vacaciones</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <!-- ********** -->
            <v-dialog
              id="dialogVacacion"
              v-model="openModalVacation"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar dark color="red">
                  <v-btn icon dark @click="openModalVacation = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>
                    <span class="headline">Solicitud de Vacaciones</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn @click="saveVacacion" dark text>Aceptar</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader>
                  <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                  <v-container fluid>
                    <v-row>
                      <v-col cols="6" sm="12" md="6">
                        <v-text-field
                          label="Fecha Inicio de Periodo"
                          v-model="Vacacion.fechaInicio"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="12" md="6">
                        <v-text-field
                          label="Fecha Fin de Periodo"
                          v-model="Vacacion.fechaFin"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="12" md="6">
                        <v-text-field
                          label="Fecha Regreso de Actividades"
                          v-model="Vacacion.fechaRegreso"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="12" md="6">
                        <v-autocomplete
                          id="selectEstatusV"
                          :items="CatEstatus"
                          item-text="descripcion"
                          item-value="idCatEstatus"
                          label="Estatus"
                          v-model="Vacacion.idCatEstatus"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list>
              </v-card>
              <v-divider></v-divider>
            </v-dialog>
            <!-- ********** -->
          </v-toolbar>
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.idVacacion">
              <td>{{ item.nombre }}</td>
              <td>{{ item.idCatLeyVacacion }}</td>
              <td>{{ item.diasSolicitados }}</td>
              <td>{{ item.fechaInicio }}</td>
              <td>{{ item.fechaFin }}</td>
              <td>{{ item.fechaRegreso }}</td>
              <td>{{ item.fechaRegistro }}</td>
              <td>
                <v-chip :color="GetColors(item.idCatEstatus)" dark>{{ item.estatus }}</v-chip>
              </td>
              <td>
                <div>
                  <!-- <v-icon small @click="pSaveVacacion(item)">edit</v-icon> -->                  
                  <v-icon small @click="saveVacacion(item, 2)">check</v-icon>
                  <v-icon small @click="saveVacacion(item, 3)">close</v-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Resetear</v-btn>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs12 sm12 pb-0 pt-0>
      <v-data-table :headers="headersO" :items="OVacaciones" :search="oSearch" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Estatus de Vacaciones</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="oSearch"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <!-- ********** -->
            <v-dialog
              id="dialogVacacionUpdate"
              v-model="openModalOthers"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar dark color="red">
                  <v-btn icon dark @click="openModalVacation = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>
                    <span class="headline">Solicitud de Vacaciones</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn @click="saveVacacion" dark text>Aceptar</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader>
                  <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                  <v-container fluid>
                    <v-row>
                      <v-row>
                        <v-col cols="4" sm="12" md="6">
                          <v-text-field
                            label="Fecha Inicio de Periodo"
                            v-model="VacacionUpdate.fechaInicio"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="12" md="6">
                          <v-text-field
                            label="Fecha Fin de Periodo"
                            v-model="VacacionUpdate.fechaFin"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="12" md="6">
                          <v-text-field
                            label="Fecha Regreso de Actividades"
                            v-model="VacacionUpdate.fechaRegreso"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-col cols="6" sm="12" md="6">
                        <v-select
                          id="selectEstatusVUpdate"
                          v-model="VacacionUpdate.idCatEstatus"
                          :items="CatEstatusUpdate"
                          item-text="descripcion"
                          item-value="idCatEstatus"
                          label="Estatus"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list>
              </v-card>
              <v-divider></v-divider>
            </v-dialog>
            <!-- ********** -->
          </v-toolbar>
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.idVacacion">
              <td>{{ item.nombre }}</td>
              <td>{{ item.idCatLeyVacacion }}</td>
              <td>{{ item.diasSolicitados }}</td>
              <td>{{ item.diasDisfrutados }}</td>
              <td>{{ item.fechaInicio }}</td>
              <td>{{ item.fechaFin }}</td>
              <td>{{ item.fechaRegreso }}</td>
              <td>{{ item.fechaRegistro }}</td>
              <td>
                <v-chip :color="GetColors(item.idCatEstatus)" dark>{{ item.estatus }}</v-chip>
              </td>
              <td>
                <div>
                  <v-icon v-if="item.idCatEstatus === 3 || item.idCatEstatus === 4" @click="saveVacacionUpdate(item, 2)">check</v-icon>
                  <v-icon v-else-if="item.idCatEstatus === 2" @click="saveVacacionUpdate(item, 3)">close</v-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Resetear</v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "Vacacion",
  components: {},
  data() {
    return {
      openModalVacation: false,
      openModalOthers: false,
      IdUsuarioKM: 0,
      Vacaciones: [],
      OVacaciones: [],
      CatEstatus: [],
      CatEstatusUpdate: [],
      CatLeyVacacion: [],
      Vacacion: {},
      VacacionUpdate: {},
      dialog: false,
      headers: [
        { text: "Nombre", value: "nombre" },
        { text: "Años de Antigüedad", value: "idCatLeyVacacion" },
        { text: "Días solicitados", value: "diasSolicitados" },
        { text: "Inicio de Periodo", value: "fechaInicio" },
        { text: "Fin de Periodo", value: "fechaFin" },
        { text: "Regreso a Actividades", value: "fechaRegreso" },
        { text: "Fecha de Solicitud", value: "fechaRegistro" },
        { text: "Estatus", value: "estatus" },
        { text: "Acción", value: "" }
      ],
      headersO: [
        { text: "Nombre", value: "nombre" },
        { text: "Años de Antigüedad", value: "idCatLeyVacacion" },
        { text: "Días solicitados", value: "diasSolicitados" },
        { text: "Días disfrutados al periodo", value: "diasDisfrutados" },
        { text: "Inicio de Periodo", value: "fechaInicio" },
        { text: "Fin de Periodo", value: "fechaFin" },
        { text: "Regreso a Actividades", value: "fechaRegreso" },
        { text: "Fecha de Solicitud", value: "fechaRegistro" },
        { text: "Estatus", value: "estatus" },
        { text: "Acción", value: "" }
      ],
      files: null,
      search: "",
      oSearch: ""
    };
  },
  created() {
    this.default();
  },
  mounted() {
    
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    }
  },
  methods: {
    default() {
      let me = this;
      me.$store.dispatch("setIsBusy", true);
      me.getCatEstatus();
      me.getUserKM();
    },
    getCatEstatus() {
      let me = this;
      me.$axios
        .get("api/Vacacions/GetCatEstatus")
        .then(r => {
          if (r) {
            me.CatEstatus = r.data.datos;
            me.CatEstatusUpdate = r.data.datos;
          }
        })
        .catch(err => console.err(err));
    },
    async getUserKM() {
      debugger;
      let me = this;
      let idUsuario = me.$store.state.sUsuario.usuario.idUsuario;
      me.$axios
        .get(`/api/Vacacions/GetUserKM?idUsuario=${idUsuario}`)
        .then(r => {
          debugger;
          if (r) {
            me.IdUsuarioKM = r.data.datos;
            me.getVacations();
            me.getOtherVacations();
          }
        })
        .catch(err => console.error(err));
    },
    async getVacations() {
      let me = this;
      me.$store.dispatch("setIsBusy", true);
      await me.$axios
        .get(`/api/Vacacions/Get?idUsuario=${me.IdUsuarioKM}`)
        .then(r => {
          if (r) {
            me.Vacaciones = r.data.datos;
            me.$store.dispatch("setIsBusy", false);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    async getOtherVacations() {
      let me = this;
      me.$store.dispatch("setIsBusy", true);
      await me.$axios
        .get(
          `/api/Vacacions/GetOther?idUsuario=${me.IdUsuarioKM}&search=${me.oSearch}`
        )
        .then(r => {
          if (r) {
            me.OVacaciones = r.data.datos;
            me.$store.dispatch("setIsBusy", false);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    GetColors(IdCatEstatus) {
      if (IdCatEstatus === 1) return "orange";
      else if (IdCatEstatus === 2) return "green";
      else return "red";
    },
    pSaveVacacion(vacacion) {
      let me = this;
      me.Vacacion = vacacion;
      me.openModalVacation = true;
    },
    pSaveVacacionUpdate(vacacion) {
      let me = this;
      me.VacacionUpdate = vacacion;
      me.openModalOthers = true;
    },
    saveVacacion(item, idCatEstatus) {
      debugger;
      let me = this;
      let vacItem = item;
      vacItem.idCatEstatus = idCatEstatus;
      vacItem.estatus = idCatEstatus === 2 ? "Aceptado" : "Rechazado";
      if (me.vacacionValidation(me.Vacacion)) {
        var vacacion = { vacacion: vacItem };
        me.$axios
          .post("api/Vacacions/SaveVacation", vacacion.vacacion)
          .then(r => {
            if (r.data.exito) {
              const index = me.Vacaciones.indexOf(item);
              if (index > -1) {
                me.Vacaciones.splice(index, 1);
              }
              //me.getOtherVacations();
              me.OVacaciones.push(item);
              this.$root.Mensaje("La solicitud ha sido procesada.");
              me.openModalVacation = false;
              me.Vacacion = {};
            }
          })
          .catch(err => console.error(err));
      }
    },
    saveVacacionUpdate(item, idCatEstatus) {
      debugger;
      let me = this;
      let vacItem = item;
      vacItem.idCatEstatus = idCatEstatus;
      vacItem.estatus = idCatEstatus === 2 ? "Aceptado" : "Rechazado";
      if (me.vacacionValidation(vacItem)) {
        var vacacion = { vacacion: vacItem };
        me.$axios
          .post("api/Vacacions/SaveVacation", vacacion.vacacion)
          .then(r => {
            if (r.data.exito) {
              //me.getVacations();
              //me.getOtherVacations();
              this.$root.Mensaje("La solicitud ha sido procesada.");
              me.openModalOthers = false;
              me.VacacionUpdate = {};
            }
          })
          .catch(err => console.error(err));
      }
    },
    vacacionValidation(vacacion) {
      let bandera = true;
      if (vacacion.idCatEstatus === 1) {
        this.$root.Mensaje(
          "Seleccione el estatus a otorgar de su solicitud",
          "error"
        );
        bandera = false;
      }

      return bandera;
    }
  }
};
</script>
